import * as React from "react";
import { useTranslation } from "@lib/useTypedTranslation";

import { Loading } from "../../../../components/loading/loading";
import { TimePeriodAndFilterPicker } from "../../../../components/timePeriodAndFilterPicker/timePeriodAndFilterPicker";
import { useFilterPicker } from "../../../../components/timePeriodAndFilterPicker/useFilterPicker";
import { useTimePeriodPicker } from "../../../../components/timePeriodAndFilterPicker/useTimePeriodPicker";
import { CoverageMap, CoverageMapProps } from "@components/maps/intensityMaps/coverage";
import { OptionPicker } from "@components/controls/optionPicker";
import { BearerTypePicker } from "@components/controls/bearerTypePicker";
import { useSimProviderOptions } from "../useSimProviderOption";

export const CoverageTab = () => {
  const ns = 'maps';
  const { t } = useTranslation(ns);

  const {
    filter,
    optionsLoading,
    ...filterPickerProps
  } = useFilterPicker();
  const { group, homeLocation, zone } = filter;

  const {
    timePeriod,
    ...timePeriodPickerProps
  } = useTimePeriodPicker({ timePeriods: [30, 7, 2] });

  const { simProviderOptions, simProvider, setSimProvider, simProvidersLoading } = useSimProviderOptions();
  const [selectedBearer, setSelectedBearer] = React.useState<string>(null);

  const coverageMapProps = React.useMemo<CoverageMapProps>(() => {
    return {
      groups: !group ? undefined : [group.value],
      homeLocations: !homeLocation ? undefined : [homeLocation.value.id],
      zoneId: zone?.value.id,
      timePeriod: timePeriod.value,
      simProvider: simProvider?.value,
      bearerType: selectedBearer
    };
  }, [group, homeLocation, zone, timePeriod, simProvider, selectedBearer]);

  return <>
    <div className="core-maps_header">
      <div className="core-maps_headings">
        <h2>{t('COVERAGE_SUBHEADING', { ns })}</h2>
      </div>
      <div className="core-maps_filters">
        <TimePeriodAndFilterPicker
          filter={filter}
          {...filterPickerProps}
          timePeriod={timePeriod}
          {...timePeriodPickerProps}
          className='core-maps_time-and-estate-filters'
        />
        <div className="core-maps-options-filters">
          <OptionPicker
            options={simProviderOptions}
            onSelect={setSimProvider}
            current={simProvider}
            disabled={simProvidersLoading}
            selectText={t('SIM_PROVIDERS', { ns })}
            id="sim-provider-picker"
          />
          <div className="radio-buttons">
            <BearerTypePicker selectedBearer={selectedBearer} onChange={setSelectedBearer} />
          </div>
        </div>
      </div>
    </div>
    <Loading isLoading={optionsLoading || simProvidersLoading} transparentOverlay={false}>
      <CoverageMap
        {...coverageMapProps}
      />
    </Loading>
  </>;
};
